var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ua from '@tencent/docs-user-agent';
import CONFIG from './config';
import { promiseAny } from './helper';
var NetStatus;
(function (NetStatus) {
    NetStatus["OFF_LINE"] = "offline";
    NetStatus["ON_LINE"] = "online";
})(NetStatus || (NetStatus = {}));
const MAX_TRY_COUNT = 15;
const BUSY_DURATION = 60000;
const FREE_DURATION = 300000;
// 断网测试
// eslint-disable-next-line no-underscore-dangle
window.__offlinetest = false;
let visibilityChange;
if (typeof document.hidden !== 'undefined') {
    visibilityChange = 'visibilitychange';
}
else if (typeof document.mozHidden !== 'undefined') {
    visibilityChange = 'mozvisibilitychange';
}
else if (typeof document.msHidden !== 'undefined') {
    visibilityChange = 'msvisibilitychange';
}
else if (typeof document.webkitHidden !== 'undefined') {
    visibilityChange = 'webkitvisibilitychange';
}
/**
 * 网络状态管理
 */
export default class NetworkManager {
    constructor(options) {
        this.cdnSources = CONFIG.cdnSources;
        this.autoRun = CONFIG.autoRun;
        this.duration = CONFIG.duration;
        this.counter = 0;
        /**
         * 页面不可见,暂停检查
         */
        this.handleVisibility = () => {
            if (document.hidden || document.webkitHidden || document.msHidden || document.mozHidden) {
                this.duration = FREE_DURATION;
                this.pause();
                this.startCheck();
            }
            else {
                this.duration = BUSY_DURATION;
                this.pause();
                this.startCheck();
            }
        };
        /**
         * 「online」与「offline」事件变化
         */
        this.handleNetstatus = () => __awaiter(this, void 0, void 0, function* () {
            this.status = yield this.netcheck();
            this.handleCalback();
        });
        this.setConfig(options);
        this.status = this.navigatorOnlineStatus;
        [this.netchecksource] = this.cdnSources;
        this.callbacks = [];
        // autoRun为false, 不执行初始化
        if (!this.autoRun) {
            return;
        }
        this.init();
    }
    static create(options) {
        const instance = new NetworkManager(options);
        return instance;
    }
    static getInstance(options) {
        if (!NetworkManager.instance) {
            NetworkManager.instance = NetworkManager.create(options);
        }
        return NetworkManager.instance;
    }
    setConfig(options) {
        const { cdnSources = this.cdnSources, ignoreDefaultSources = CONFIG.ignoreDefaultSources, autoRun = this.autoRun, duration = this.duration, } = options;
        if (Array.isArray(cdnSources)) {
            if (ignoreDefaultSources) {
                this.cdnSources = cdnSources;
            }
            else {
                this.cdnSources = this.cdnSources.concat(cdnSources);
            }
        }
        this.autoRun = !!autoRun;
        if (Number.isInteger(duration)) {
            this.duration = duration;
        }
    }
    getVersion() {
        return NetworkManager.version;
    }
    /**
     * 初始化
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const status = yield this.preNetCheck();
            this.status = status;
            this.bindVisibility();
            this.bindNetStatus();
            this.startCheck();
        });
    }
    /**
     * 检查是否在线
    */
    get isOnline() {
        // eslint-disable-next-line no-underscore-dangle
        if (window.__offlinetest) {
            return false;
        }
        return this.status === NetStatus.ON_LINE;
    }
    /**
     * 绑定网络变化回掉
     * @param callback
     */
    changeEnd(callback) {
        this.callbacks.push(callback);
    }
    /**
     * 转移回调函数, 用于新版本更新
     * @param callbacks
     */
    extendCallbacks(callbacks) {
        this.callbacks = this.callbacks.concat(callbacks.slice());
    }
    /**
     * 获取所有回调函数
     */
    getCallbacks() {
        return this.callbacks;
    }
    /**
     * 移除绑定
     * @param callback
    */
    remove(callback) {
        const list = this.callbacks.slice(0, this.callbacks.length);
        for (let i = 0; i < list.length; i++) {
            if (list[i] === callback) {
                list.splice(i, 1);
                this.callbacks = list;
            }
        }
    }
    /**
     * 处理回调
     */
    handleCalback() {
        this.callbacks.forEach((callback) => {
            callback(this.status);
        });
    }
    destory() {
        if (window.mqq && ua.isAndroid && (ua.isTencentDocsApp || ua.isTimOrQQ) && !ua.isQQMiniProgram) {
            window.mqq.removeEventListener('qbrowserVisibilityChange', this.handleVisibility);
        }
        else {
            document.removeEventListener(visibilityChange, this.handleVisibility);
        }
        this.pause();
        window.removeEventListener(NetStatus.ON_LINE, this.handleNetstatus);
        window.removeEventListener(NetStatus.OFF_LINE, this.handleNetstatus);
        this.counter = 0;
        this.preCheckOnlineStatus = false;
        this.duration = BUSY_DURATION;
    }
    bindNetStatus() {
        window.addEventListener(NetStatus.ON_LINE, this.handleNetstatus);
        window.addEventListener(NetStatus.OFF_LINE, this.handleNetstatus);
    }
    /**
     * 绑定页面可视状态
     */
    bindVisibility() {
        if (window.mqq && ua.isAndroid && (ua.isTencentDocsApp || ua.isTimOrQQ) && !ua.isQQMiniProgram) {
            window.mqq.addEventListener('qbrowserVisibilityChange', this.handleVisibility);
        }
        else {
            document.addEventListener(visibilityChange, this.handleVisibility);
        }
    }
    /**
     * 暂停检查
     */
    pause() {
        clearInterval(this.Timer);
        this.Timer = null;
    }
    /**
     * 启动检查
     */
    startCheck() {
        // 循环检测
        this.Timer = window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
            yield this.polling();
        }), this.duration);
    }
    /**
     * 进行持续检查
     */
    polling() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.preCheckOnlineStatus) {
                this.status = this.navigatorOnlineStatus;
            }
            else {
                this.status = yield this.netcheck();
            }
            // 15 * 200
            if (this.counter >= MAX_TRY_COUNT) {
                yield this.preNetCheck();
                this.counter = 0;
            }
            else {
                this.counter += 1;
            }
            this.handleCalback();
        });
    }
    get navigatorOnlineStatus() {
        return window.navigator.onLine ? NetStatus.ON_LINE : NetStatus.OFF_LINE;
    }
    /**
     * 进行 CDN 资源预检, 使用最快相应的资源
     * @returns Promise<string>
     */
    preNetCheck() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                const preNetCheckPromises = this.cdnSources.map((value) => this.sourceCheck(value));
                promiseAny(preNetCheckPromises)
                    .then((url) => {
                    this.preCheckOnlineStatus = true;
                    this.netchecksource = url;
                    resolve(NetStatus.ON_LINE);
                    // 检查所有的图片资源是否能成功加载, 只要有能够成功加载的, 就使用这个资源
                })
                    .catch(() => {
                    this.preCheckOnlineStatus = false;
                    resolve(NetStatus.OFF_LINE);
                });
            });
        });
    }
    /**
     * 进行资源检查
     * @param url
     * @return void
     */
    sourceCheck(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const preImage = new Image();
            return new Promise((resolve, reject) => {
                preImage.onload = () => {
                    resolve(url);
                };
                preImage.onerror = () => {
                    // 失败设置resolve全部走then,不走catch
                    reject(`${url} load fail`);
                };
                preImage.src = `${url}?t=${Date.now()}`;
            });
        });
    }
    /**
     * 进行网络检查
     * @returns Promise<string>
     */
    netcheck() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.netcheckImage) {
                this.netcheckImage = new Image();
            }
            return new Promise((resolve) => {
                this.netcheckImage.onload = function () {
                    resolve(NetStatus.ON_LINE);
                };
                this.netcheckImage.onerror = function () {
                    resolve(NetStatus.OFF_LINE);
                };
                this.netcheckImage.src = `${this.netchecksource}?t=${Date.now()}`;
            });
        });
    }
}
NetworkManager.version = CONFIG.version;
//# sourceMappingURL=network-manager.js.map